function convertToStandardRomanization(word) {
    var convertedWord = word.replace(/[\u014C\u014D]/g, 'o').replace(/[\u016B\u016D]/g, 'u');
    return convertedWord;
}

function convertPrefectureToEn(prefecture) {
    const PREFECTURES = {
        "北海道": "Hokkaido",
        "青森県": "Aomori",
        "岩手県": "Iwate",
        "宮城県": "Miyagi",
        "秋田県": "Akita",
        "山形県": "Yamagata",
        "福島県": "Fukushima",
        "茨城県": "Ibaraki",
        "栃木県": "Tochigi",
        "群馬県": "Gunma",
        "埼玉県": "Saitama",
        "千葉県": "Chiba",
        "東京都": "Tokyo",
        "神奈川県": "Kanagawa",
        "新潟県": "Niigata",
        "富山県": "Toyama",
        "石川県": "Ishikawa",
        "福井県": "Fukui",
        "山梨県": "Yamanashi",
        "長野県": "Nagano",
        "岐阜県": "Gifu",
        "静岡県": "Shizuoka",
        "愛知県": "Aichi",
        "三重県": "Mie",
        "滋賀県": "Shiga",
        "京都府": "Kyoto",
        "大阪府": "Osaka",
        "兵庫県": "Hyogo",
        "奈良県": "Nara",
        "和歌山県": "Wakayama",
        "鳥取県": "Tottori",
        "島根県": "Shimane",
        "岡山県": "Okayama",
        "広島県": "Hiroshima",
        "山口県": "Yamaguchi",
        "徳島県": "Tokushima",
        "香川県": "Kagawa",
        "愛媛県": "Ehime",
        "高知県": "Kochi",
        "福岡県": "Fukuoka",
        "佐賀県": "Saga",
        "長崎県": "Nagasaki",
        "熊本県": "Kumamoto",
        "大分県": "Oita",
        "宮崎県": "Miyazaki",
        "鹿児島県": "Kagoshima",
        "沖縄県": "Okinawa",
    };
    return PREFECTURES[prefecture];
}

/**
 * Shopify ISO 3166-2 都道府県コード（JP-01〜JP-47）を返す。住所更新APIで必須になることがある。
 * @param {string} prefecture - 都道府県名（日本語または英語）
 * @returns {string|undefined} - 例: "JP-13" (東京都)、該当なしなら undefined
 */
function getProvinceCodeForJapan(prefecture) {
  if (!prefecture || typeof prefecture !== 'string') return undefined;
  const trimmed = prefecture.trim();
  const JP_CODES = {
    "北海道": "JP-01", "青森県": "JP-02", "岩手県": "JP-03", "宮城県": "JP-04", "秋田県": "JP-05",
    "山形県": "JP-06", "福島県": "JP-07", "茨城県": "JP-08", "栃木県": "JP-09", "群馬県": "JP-10",
    "埼玉県": "JP-11", "千葉県": "JP-12", "東京都": "JP-13", "神奈川県": "JP-14", "新潟県": "JP-15",
    "富山県": "JP-16", "石川県": "JP-17", "福井県": "JP-18", "山梨県": "JP-19", "長野県": "JP-20",
    "岐阜県": "JP-21", "静岡県": "JP-22", "愛知県": "JP-23", "三重県": "JP-24", "滋賀県": "JP-25",
    "京都府": "JP-26", "大阪府": "JP-27", "兵庫県": "JP-28", "奈良県": "JP-29", "和歌山県": "JP-30",
    "鳥取県": "JP-31", "島根県": "JP-32", "岡山県": "JP-33", "広島県": "JP-34", "山口県": "JP-35",
    "徳島県": "JP-36", "香川県": "JP-37", "愛媛県": "JP-38", "高知県": "JP-39", "福岡県": "JP-40",
    "佐賀県": "JP-41", "長崎県": "JP-42", "熊本県": "JP-43", "大分県": "JP-44", "宮崎県": "JP-45",
    "鹿児島県": "JP-46", "沖縄県": "JP-47",
    "Hokkaido": "JP-01", "Aomori": "JP-02", "Iwate": "JP-03", "Miyagi": "JP-04", "Akita": "JP-05",
    "Yamagata": "JP-06", "Fukushima": "JP-07", "Ibaraki": "JP-08", "Tochigi": "JP-09", "Gunma": "JP-10",
    "Saitama": "JP-11", "Chiba": "JP-12", "Tokyo": "JP-13", "Kanagawa": "JP-14", "Niigata": "JP-15",
    "Toyama": "JP-16", "Ishikawa": "JP-17", "Fukui": "JP-18", "Yamanashi": "JP-19", "Nagano": "JP-20",
    "Gifu": "JP-21", "Shizuoka": "JP-22", "Aichi": "JP-23", "Mie": "JP-24", "Shiga": "JP-25",
    "Kyoto": "JP-26", "Osaka": "JP-27", "Hyogo": "JP-28", "Nara": "JP-29", "Wakayama": "JP-30",
    "Tottori": "JP-31", "Shimane": "JP-32", "Okayama": "JP-33", "Hiroshima": "JP-34", "Yamaguchi": "JP-35",
    "Tokushima": "JP-36", "Kagawa": "JP-37", "Ehime": "JP-38", "Kochi": "JP-39", "Fukuoka": "JP-40",
    "Saga": "JP-41", "Nagasaki": "JP-42", "Kumamoto": "JP-43", "Oita": "JP-44", "Miyazaki": "JP-45",
    "Kagoshima": "JP-46", "Okinawa": "JP-47"
  };
  return JP_CODES[trimmed] || undefined;
}

function convertPrefecture(prefecture) {
    const PREFECTURES = {
        "hokkaido": "北海道",
        "aomori": "青森県",
        "iwate": "岩手県",
        "miyagi": "宮城県",
        "akita": "秋田県",
        "yamagata": "山形県",
        "fukushima": "福島県",
        "ibaraki": "茨城県",
        "tochigi": "栃木県",
        "gunma": "群馬県",
        "saitama": "埼玉県",
        "chiba": "千葉県",
        "tokyo": "東京都",
        "kanagawa": "神奈川県",
        "niigata": "新潟県",
        "toyama": "富山県",
        "ishikawa": "石川県",
        "fukui": "福井県",
        "yamanashi": "山梨県",
        "nagano": "長野県",
        "gifu": "岐阜県",
        "shizuoka": "静岡県",
        "aichi": "愛知県",
        "mie": "三重県",
        "shiga": "滋賀県",
        "kyoto": "京都府",
        "osaka": "大阪府",
        "hyogo": "兵庫県",
        "nara": "奈良県",
        "wakayama": "和歌山県",
        "tottori": "鳥取県",
        "shimane": "島根県",
        "okayama": "岡山県",
        "hiroshima": "広島県",
        "yamaguchi": "山口県",
        "tokushima": "徳島県",
        "kagawa": "香川県",
        "ehime": "愛媛県",
        "kochi": "高知県",
        "fukuoka": "福岡県",
        "saga": "佐賀県",
        "nagasaki": "長崎県",
        "kumamoto": "熊本県",
        "oita": "大分県",
        "miyazaki": "宮崎県",
        "kagoshima": "鹿児島県",
        "okinawa": "沖縄県",
    };
    return PREFECTURES[prefecture.toLowerCase()];
}
  